class OrderConfirmabilityStatus {
    is_confirmable = false;

    error_id = null;

    error_title = null;

    error_message = null;

    constructor(event_emitter) {
        this.bind = event_emitter.bind;
        this.unbind = event_emitter.unbind;
        this.once = event_emitter.once;
        this.trigger = event_emitter.trigger;
    }

    isConfirmable() {
        return this.is_confirmable;
    }

    getErrorId() {
        return this.error_id;
    }

    getErrorTitle() {
        return this.error_title;
    }

    getErrorMessage() {
        return this.error_message;
    }

    setIsConfirmable(is_confirmable) {
        const new_is_confirmable = !!is_confirmable;

        if (this.is_confirmable === new_is_confirmable) {
            return;
        }
        this.is_confirmable = new_is_confirmable;
        this.trigger('updateIsConfirmable', this.is_confirmable);
    }

    setErrorId(error_id) {
        if (this.error_id === error_id) {
            return;
        }

        this.error_id = error_id;
        this.trigger(
            'updateProgressConfirmabilityStatusErrorId',
            this.error_id
        );
    }

    setErrorTitle(error_title) {
        if (this.error_title === error_title) {
            return;
        }

        this.error_title = error_title;
        this.trigger(
            'updateProgressConfirmabilityStatusErrorTitle',
            this.error_title
        );
    }

    setErrorMessage(error_message) {
        if (this.error_message === error_message) {
            return;
        }

        this.error_message = error_message;
        this.trigger(
            'updateProgressConfirmabilityStatusErrorMessage',
            this.error_message
        );
    }

    set(status) {
        if ('error_message' in status) {
            this.setErrorMessage(status.error_message);
        }
        if ('error_title' in status) {
            this.setErrorTitle(status.error_title);
        }
        if ('error_id' in status) {
            this.setErrorId(status.error_id);
        }
        if ('is_confirmable' in status) {
            this.setIsConfirmable(status.is_confirmable);
        }
    }
}

Mobi2Go._class = Mobi2Go._class || {};
Mobi2Go._class.OrderConfirmabilityStatus = OrderConfirmabilityStatus;

export default OrderConfirmabilityStatus;
